const BASE_API_URL = process.env.REACT_APP_API_BASE_URL!;

export { BASE_API_URL };